import { createFileRoute } from "@tanstack/react-router";
import { useIntl } from "react-intl";

import { TripList } from "@/features/trips/components/TripList";

export const Route = createFileRoute("/_authenticated/trips/search")({
  component: RouteComponent,
});

function RouteComponent() {
  const intl = useIntl();

  return (
    <main className="w-full space-y-4 p-main">
      <h1 className="text-lg font-medium text-text-title">
        {intl.formatMessage({
          id: "trips.search.title",
          defaultMessage: "Explore tour packages",
        })}
      </h1>

      <TripList />
    </main>
  );
}
